<template>
    <div class="mainQuestions">
        <div class="answerItems">
            <div class="questionMenu">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{ activeGroup.name }}</el-breadcrumb-item>
                    <el-breadcrumb-item
                        ><span @click="changePage()" class="main-menu">{{
                            activeQuestion.name
                        }}</span></el-breadcrumb-item
                    >
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="question-items">{{ answerTxt.q }}</div>
            <div class="answer-time">更新时间：{{ answerTxt.time }}</div>
            <el-divider></el-divider>
            <div class="answer-items" v-html="answerTxt.a"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'answer',
    props: ['activeQuestion', 'activeGroup', 'answerTxt'],
    data() {
        return {};
    },
    methods: {
        changePage() {
            this.$emit('answerMessage');
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.mainQuestions
  width 100%
  overflow-y auto
  overflow-x hidden
.mainQuestions::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  height: 1px;
}
.mainQuestions::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #F0F0F0;
}
.mainQuestions::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 10px;
  background: #f2f8fe;
}
.answerItems
  /*height 100%*/
  width 100%
  margin-left 2.5%
.questionMenu
  height 3%
  margin-top 2.5%
.question-items
  padding-top 20px
  color black
  font-weight bold
  font-size 1.5rem
  width 98%
.answer-items
  color black
  line-height: 25px;
  width 90%
.answer-time
  color black
  padding-top 1%
.main-menu
  color: #0c78e2;
  cursor: pointer;
.main-menu:hover
  text-decoration:underline;
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/answer.vue